import React, { createContext, useEffect, useState } from 'react';
import apiendpoint from '../apiendpoints.json'

const AuthContext = createContext();

const AuthProvider = ({ children }) => {


    const [authUser, setAuthUser] = useState(null);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [userDetails, setUserDetails] = useState({});

    const authValue = { authUser, setAuthUser, userLoggedIn, setUserLoggedIn, userDetails, setUserDetails };

    useEffect(() => {
        // console.log('AuthProvider userLoggedIn ', authUser)
        if (authUser?.roleId === 1) {
            const url = `${apiendpoint.API_BASE_URL}/Teacher/GetTeachersClassSection?userid=${authUser.userId}`;
            const headers = {
                accept: '*/*',
                schoolid: authUser.schoolId
            };

            fetch(url, {
                method: 'GET',
                headers: headers,
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    setUserDetails(data.data)
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }

    }, [userLoggedIn])


    return (
        <AuthContext.Provider value={authValue}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext };
export default AuthProvider;
